import React, { useState } from "react";
import { Line } from "react-chartjs-2";
// import Chart from "chart.js";

const ChartComponent = ({ value, score }) => {
  const [isMobile] = useState(window.innerWidth < 600);

  const generateDataSet = (score, value) => {
    const dataset = Array(11).fill(null);
    if (score >= 0 && score <= 10) {
      dataset[score] = value;
    }
    return dataset;
  };

  const data = {
    labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    datasets: [
      {
        label: "",
        data: generateDataSet(score, value),
        pointRadius: 8,
        pointHoverRadius: 13,
        pointBackgroundColor: "#f56336ff",
        pointBorderColor: "transparent",
        fill: false,
        borderColor: "transparent",
        borderWidth: 0,
      },
      {
        label: "Symptoms Only",
        data: [5, 11.2, 20.5, 29.7, 35.5, 38.2, 39.3, 39.9, 40, 40, 40],
        lineTension: 0.4,
        // borderColor: "#032d53ff", // BLUE-THEME
        borderColor: "#005F73", // GREEN-THEME
        borderWidth: 3,
        pointRadius: 0,
        pointHoverRadius: 0,
        fill: false,
      },
    ],
  };

  const margins = isMobile
    ? { top: 10, left: 10, right: 9, bottom: 17 } // Mobile
    : { top: 20, left: 20, right: 155, bottom: 35 }; // Desktop

  // Custom plugin for Chart.js v2
  const showValuePlugin = {
    afterDatasetsDraw: function (chart) {
      const ctx = chart.ctx;

      chart.data.datasets.forEach((dataset, datasetIndex) => {
        if (dataset.label === "") {
          const meta = chart.getDatasetMeta(datasetIndex);
          meta.data.forEach((point, index) => {
            const val = dataset.data[index];
            if (val !== null && val !== undefined) {
              ctx.save();
              ctx.fillStyle = "#f56336";
              ctx.font = "bold 12px sans-serif";
              const displayVal = Math.round(val) + "%";

              if (index === 0) {
                ctx.textAlign = "left";
                ctx.textBaseline = "middle";
                ctx.fillText(displayVal, point._model.x + 12, point._model.y);
              } else if (
                (index === 1 || index === 2 || index === 3 || index === 4) &&
                isMobile
              ) {
                ctx.textAlign = "left";
                ctx.textBaseline = "right";
                ctx.fillText(displayVal, point._model.x + 12, point._model.y);
              } else if (index === 2 || index === 3) {
                ctx.textAlign = "left";
                ctx.textBaseline = "right";
                ctx.fillText(
                  displayVal,
                  point._model.x - 2,
                  point._model.y + 18
                );
              } else if (index === dataset.data.length - 1) {
                ctx.textAlign = "left";
                ctx.textBaseline = "bottom";
                ctx.fillText(displayVal, point._model.x, point._model.y);
              } else {
                ctx.textAlign = "center";
                ctx.textBaseline = "top";
                ctx.fillText(displayVal, point._model.x, point._model.y + 12);
              }
              ctx.restore();
            }
          });
        }
      });
    },
  };

  const textBoxPlugin = {
    afterDatasetsDraw: function (chart) {
      const ctx = chart.ctx;
      const meta = chart.getDatasetMeta(0);
      const activePoint = meta.data.find((p) => p._model.y !== null);
      if (!activePoint) return;
      // Read latest value from dataset instead of using closure variable
      const dataset = chart.data.datasets[0];
      const pointValue = dataset.data.find((v) => v !== null);
      if (!pointValue) return;

      const text = `Your estimated probability of having axial spondyloarthritis is ${Math.round(pointValue)}%. If it’s >33%, rheumatology referral is recommended. Discuss with your healthcare provider about next steps.`;

      const padding = isMobile ? 8 : 12;
      const maxWidth = isMobile ? 168 : 280;
      const fontSize = isMobile ? 11 : 14;
      const lineHeight = Math.round(fontSize * 1.35);
      ctx.font = `400 ${fontSize}px Arial`;

      //Wrap text
      const words = text.split(" ");
      let line = "";
      let lines = [];
      for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n] + " ";
        if (ctx.measureText(testLine).width > maxWidth - padding * 2 && n > 0) {
          lines.push(line);
          line = words[n] + " ";
        } else {
          line = testLine;
        }
      }
      lines.push(line);

      const boxHeight = lines.length * lineHeight + padding * 2;
      const boxWidth = maxWidth;

      const chartArea = chart.chartArea;

      // ✅ Two fixed candidate positions
      const candidates = [
        {
          x: chartArea.right - boxWidth - margins.right,
          y: chartArea.bottom - boxHeight - margins.bottom,
        },
        {
          x: chartArea.left + margins.left,
          y: chartArea.top + margins.top,
        },
      ];

      // Pick one position → e.g., prefer top-left, else fallback bottom-right
      let chosen = candidates.find(
        (pos) =>
          pos.x >= chartArea.left &&
          pos.x + boxWidth <= chartArea.right &&
          pos.y >= chartArea.top &&
          pos.y + boxHeight <= chartArea.bottom
      );
      if (!chosen) chosen = candidates[0]; // fallback = bottom-right

      // Draw background
      ctx.save();
      ctx.fillStyle = "#f7f9fc";
      ctx.strokeStyle = "#225491";
      ctx.lineWidth = 1.5;
      ctx.fillRect(chosen.x, chosen.y, boxWidth, boxHeight);
      ctx.strokeRect(chosen.x, chosen.y, boxWidth, boxHeight);

      // Draw text
      ctx.fillStyle = "#1f2933";
      ctx.textBaseline = "top";

      let textY = chosen.y + padding;

      lines.forEach((line) => {
        ctx.fillText(line, chosen.x + padding, textY);
        textY += lineHeight;
      });
      ctx.restore();
    },
  };

  // Chart.plugins.unregister(showValuePlugin);
  // Chart.plugins.unregister(textBoxPlugin);
  // Chart.plugins.register(showValuePlugin);
  // Chart.plugins.register(textBoxPlugin);

  const options = {
    tooltips: {
      enabled: false,
    },
    legend: {
      display: true,
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          ticks: {
            fontColor: "#0a0303ff",
            fontSize: 14,
          },
          gridLines: {
            color: "#9B9B9B",
            drawOnChartArea: false,
            lineWidth: 2,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            min: 0,
            max: 45,
            stepSize: 5,
            fontColor: "#0a0303ff",
          },
          gridLines: {
            color: "#9B9B9B",
            drawOnChartArea: false,
            lineWidth: 2,
          },
        },
      ],
    },
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: isMobile ? "320px" : "800px",
        height: isMobile ? "350px" : "450px",
        margin: "0 auto",
      }}
    >
      <Line
        data={data}
        options={options}
        plugins={[showValuePlugin, textBoxPlugin]}
      />
    </div>
  );
};

export default ChartComponent;
